import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-terms-modal',
  templateUrl: './terms-modal.component.html',
  styleUrl: './terms-modal.component.scss',
  providers: [NgbActiveModal]
})
export class TermsModalComponent {

  @Input() title: string = '';
  @Output() close = new EventEmitter<void>();

  closeModal() {
    this.close.emit();
  }

  constructor(public activeModal: NgbActiveModal) {
  }

}
